import React, { ReactElement, useState } from 'react';
import { Details, Loader } from 'idsk-react-components';
import Layout from '../Layout';
import {
  SubjektBezPripomienokList,
  useSubjektBezPripomienokListPage,
} from '../../module/SubjektBezPripomienokList';
import './pripomienkaListPage.scss';
import { PripomienkaList } from '../../module/PripomienkaList';
import Filter from '../../module/Filter/Filter';
import useFilterData from '../../module/PripomienkaList/hooks/useFilterData';
import ClassType from '../../model/pripomienka/ClassType';
import useFilterPripomienkaList from '../../module/PripomienkaList/hooks/useFilterPripomienkaList';
import ConfirmAction from '../../module/ConfirmAction/ConfirmAction';
import { useUserContext } from '../../context/UserContext';
import { StadiumMaterialuEnum } from '../../model/StadiumMaterialu';
import hasBeenInStadium from '../../function/hasBeenInStadium';
import { useStadiumMaterialuHistoriaContext } from '../../context/StadiumMaterialuHistoriaContext';
import emptyFilter from '../../module/PripomienkaList/emptyFilter';
import Secured from '../../module/Secured';
import { isAdmin, isAktualnyPredkladatel } from '../../function/permissions';
import { ForbiddenPage } from '../index';

export default (): ReactElement => {
  const [assignedList, setAssignedList] = useState([]);
  const {
    subjektBezPripomienokListPage,
    subjektStatus,
    subjPageNumberFromUrl,
    reloadSubjektBezPripomienokList,
  } = useSubjektBezPripomienokListPage();
  const { pouzivatel } = useUserContext();

  const {
    filterData,
    filterDataStatus,
    reloadFilterData,
  } = useFilterData(ClassType.PRIPOMIENKA);

  const {
    legislationProcess: legislativnyProces,
  } = useUserContext();
  const { stadiumMaterialuHistoria } = useStadiumMaterialuHistoriaContext();

  const {
    pripomienkaListPage,
    pripomienkaStatus,
    pripomienkaPageNumberFromUrl,
    reloadPripomienkyList,
    filter,
  } = useFilterPripomienkaList(ClassType.PRIPOMIENKA);

  if (legislativnyProces?.stadiumProcesu === StadiumMaterialuEnum.PRIPRAVA_MATERIALU
      && hasBeenInStadium(StadiumMaterialuEnum.MPK, stadiumMaterialuHistoria?.historiaRecords)) {
    return (
      <Layout
        assignedList={assignedList}
        reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
        reloadPripomienkyList={reloadPripomienkyList}
        setAssignedList={setAssignedList}
        reloadFilterData={reloadFilterData}
      >
        <Secured
          additionalCheck={isAdmin(pouzivatel) || isAktualnyPredkladatel(pouzivatel, legislativnyProces)}
          elseChildren={<ForbiddenPage />}
        >
          <>
            {filterData && (
              <Loader loading={filterDataStatus?.loading}>
                <Filter
                  filter={filter}
                  filterData={filterData}
                />
              </Loader>
            )}
            <ConfirmAction />
            <Details summary="Subjekty bez pripomienok">
              <SubjektBezPripomienokList
                page={subjektBezPripomienokListPage}
                status={subjektStatus}
                pageNumberFromUrl={subjPageNumberFromUrl}
                reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
              />
            </Details>
            <PripomienkaList
              page={pripomienkaListPage}
              status={pripomienkaStatus}
              pageNumberFromUrl={pripomienkaPageNumberFromUrl}
              assignedList={assignedList}
              setAssignedList={setAssignedList}
              reloadPripomienkaListPage={reloadPripomienkyList}
              reloadFilterData={reloadFilterData}
              isSelectedFilter={JSON.stringify(filter) !== JSON.stringify(emptyFilter)}
            />
          </>
        </Secured>
      </Layout>
    );
  }

  return (
    <Layout
      assignedList={assignedList}
      reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
      reloadPripomienkyList={reloadPripomienkyList}
      setAssignedList={setAssignedList}
      reloadFilterData={reloadFilterData}
    >
      <>
        {filterData && (
          <Loader loading={filterDataStatus?.loading}>
            <Filter
              filter={filter}
              filterData={filterData}
            />
          </Loader>
        )}
        <ConfirmAction />
        <Details summary="Subjekty bez pripomienok">
          <SubjektBezPripomienokList
            page={subjektBezPripomienokListPage}
            status={subjektStatus}
            pageNumberFromUrl={subjPageNumberFromUrl}
            reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
          />
        </Details>
        <PripomienkaList
          page={pripomienkaListPage}
          status={pripomienkaStatus}
          pageNumberFromUrl={pripomienkaPageNumberFromUrl}
          assignedList={assignedList}
          setAssignedList={setAssignedList}
          reloadPripomienkaListPage={reloadPripomienkyList}
          reloadFilterData={reloadFilterData}
          isSelectedFilter={JSON.stringify(filter) !== JSON.stringify(emptyFilter)}
        />
      </>
    </Layout>
  );
};
